import React from 'react';
import { Field } from 'redux-form';
import NumberFormat from 'react-number-format';
import {
    renderFieldCheck,
    renderFieldNumeros,
    renderFieldNumerosPorcentagem,
    renderFieldSelect,
    required,
    requiredSelect,
    tamanhoHoraMinuto,
    tamanhoPorcentagem,
    validateHora,
    validateMinutos,
} from '../../util/inputs';
import { tipoAjusteItinerario } from '../../util/constantsUtil';

const FieldsetConfiguracaoPreco = ({
    // flags
    exibirAjuste,
    exibirAjustePrioritario,
    // regras gerais
    tipoConfiguracaoPreco,
    quantidadePoltronasRegra,
    // regras por usuário
    tipoConfiguracaoPrecoPrioritario,
    quantidadePoltronasRegraPrioritario,
    // dados auxiliares
    tiposConfiguracoesPreco,
    tiposConfiguracoesPrecoPrioritario,
    usuariosVendedores,
    vendedoresSelecionados,
    // handlers
    onToggleAjuste,
    onToggleAjustePrioritario,
    onAdicionarPricePorUsuario,
    onRemoverUsuarioVendedor,
}) => {
    const mostrarCampoHora = (config) =>
        config && config.value === 'DATA_PARTIDA';

    const mostrarCampoQuantidadePoltronas = (config) =>
        config &&
        (config.value === 'POLTRONAS_VENDIDAS_A_CADA' ||
            config.value === 'POLTRONAS_VENDIDAS_A_PARTIR' ||
            config.value === 'POLTRONAS_VENDIDAS_ATE_NUMERO');

    const renderFieldHoraLocal = ({
        input,
        label,
        css,
        max,
        readOnly,
        meta: { touched, error },
    }) => (
        <div>
            <label className="mt-2">{label}</label>
            <div>
                <NumberFormat
                    {...input}
                    format="##:##"
                    className={css}
                    maxLength={max}
                    style={{ borderColor: touched && error ? 'red' : '' }}
                    readOnly={readOnly}
                />
                {touched && error && (
                    <span style={{ color: 'red' }}>{error}</span>
                )}
            </div>
        </div>
    );

    const renderTabelaVendedores = () => (
        <table className="table table-sm table-bordered">
            <thead>
                <tr className="text-center">
                    <th colSpan="5">Vendedores</th>
                </tr>
                <tr>
                    <th>ID</th>
                    <th>Desconto/Acréscimo</th>
                    <th>Valor(%)</th>
                    <th>Descricao</th>
                    <th />
                </tr>
            </thead>
            <tbody>
                {!vendedoresSelecionados || vendedoresSelecionados.length === 0 ? (
                    <tr className="alert alert-warning text-center mt-4" role="alert">
                        <td colSpan="5">Nenhum vendedor foi cadastrado.</td>
                    </tr>
                ) : (
                    vendedoresSelecionados.map((vendedor) => (
                        <tr key={vendedor.id}>
                            <td>{vendedor.id}</td>
                            <td>{vendedor.tipoAjusteItinerario.label}</td>
                            <td>{vendedor.valorAjuste}</td>
                            <td>{vendedor.vendedor.label}</td>
                            <td
                                className="text-center"
                                style={{ cursor: 'pointer', color: 'red' }}
                            >
                                <div onClick={() => onRemoverUsuarioVendedor(vendedor.id)}>
                                    Remover
                                </div>
                            </td>
                        </tr>
                    ))
                )}
            </tbody>
        </table>
    );

    return (
        <>
            <fieldset className="scheduler-border">
                <legend className="scheduler-border">Configuração de preço</legend>
                <div className="col-12 col-sm-12 col-md-12">
                    <Field
                        type="checkbox"
                        name="exibirAjuste"
                        component={renderFieldCheck}
                        label="Incluir desconto ou acréscimo na passagem"
                        css="form-check-input"
                        readOnly={false}
                        onChange={onToggleAjuste}
                    />
                </div>

                {exibirAjuste && (
                    <>
                        <div className="col-12 col-sm-3 col-md-3">
                            <Field
                                name="tipoAjusteItinerario"
                                options={tipoAjusteItinerario.map((elemento) => ({
                                    descricao: elemento.label,
                                    nome: elemento.value,
                                }))}
                                component={renderFieldSelect}
                                label="Descontos/Acréscimos"
                                placeholder="Selecione um tipo"
                                validate={requiredSelect}
                            />
                        </div>
                        <div className="col-12 col-sm-2 col-md-2">
                            <Field
                                name="valorAjuste"
                                validate={[required, tamanhoPorcentagem]}
                                component={renderFieldNumerosPorcentagem}
                                css="form-control"
                                label="Desconto/Acréscimo(%):"
                            />
                        </div>
                        <div className="col-12 col-sm-5 col-md-5">
                            <Field
                                name="tipoConfiguracaoPreco"
                                options={tiposConfiguracoesPreco.map((elemento) => ({
                                    descricao: elemento.label,
                                    nome: elemento.value,
                                }))}
                                component={renderFieldSelect}
                                label="Regra de desconto/acréscimo"
                                validate={requiredSelect}
                            />
                        </div>

                        {mostrarCampoHora(tipoConfiguracaoPreco) && (
                            <div className="col-12 col-sm-2 col-md-2">
                                <Field
                                    name="horaPartidaRegra"
                                    css="form-control"
                                    component={renderFieldHoraLocal}
                                    label="Hora"
                                    validate={[
                                        required,
                                        validateMinutos,
                                        validateHora,
                                        tamanhoHoraMinuto,
                                    ]}
                                />
                            </div>
                        )}

                        {mostrarCampoQuantidadePoltronas(tipoConfiguracaoPreco) && (
                            <div className="col-12 col-sm-2 col-md-2 mt-2">
                                <label>Número de poltronas</label>
                                <Field
                                    name="quantidadePoltronasRegra"
                                    type="text"
                                    component={renderFieldNumeros}
                                    valor={quantidadePoltronasRegra}
                                    formatacao="##"
                                    css="form-control"
                                />
                            </div>
                        )}
                    </>
                )}
            </fieldset>

            <fieldset className="scheduler-border">
                <legend className="scheduler-border">Configuração de preço por usuário</legend>
                <div className="col-12 col-sm-12 col-md-12">
                    <Field
                        type="checkbox"
                        name="exibirAjustePrioritario"
                        component={renderFieldCheck}
                        label="Incluir desconto ou acréscimo na passagem"
                        css="form-check-input"
                        readOnly={false}
                        onChange={onToggleAjustePrioritario}
                    />
                </div>

                {exibirAjustePrioritario && (
                    <>
                        <div className="col-12 col-sm-3 col-md-3">
                            <Field
                                name="tipoAjusteItinerarioPrioritario"
                                options={tipoAjusteItinerario.map((elemento) => ({
                                    descricao: elemento.label,
                                    nome: elemento.value,
                                }))}
                                component={renderFieldSelect}
                                label="Descontos/Acréscimos"
                                placeholder="Selecione um tipo"
                            />
                        </div>
                        <div className="col-12 col-sm-2 col-md-2">
                            <Field
                                name="valorAjustePrioritario"
                                component={renderFieldNumerosPorcentagem}
                                css="form-control"
                                label="Desconto/Acréscimo(%):"
                            />
                        </div>
                        <div className="col-12 col-sm-5 col-md-5">
                            <Field
                                name="tipoConfiguracaoPrecoPrioritario"
                                options={tiposConfiguracoesPrecoPrioritario.map(
                                    (elemento) => ({
                                        descricao: elemento.label,
                                        nome: elemento.value,
                                    })
                                )}
                                component={renderFieldSelect}
                                label="Regra de desconto/acréscimo"
                                validate={requiredSelect}
                            />
                        </div>

                        {mostrarCampoHora(tipoConfiguracaoPrecoPrioritario) && (
                            <div className="col-12 col-sm-2 col-md-2">
                                <Field
                                    name="horaPartidaRegraPrioritario"
                                    css="form-control"
                                    component={renderFieldHoraLocal}
                                    label="Hora"
                                    validate={[
                                        required,
                                        validateMinutos,
                                        validateHora,
                                        tamanhoHoraMinuto,
                                    ]}
                                />
                            </div>
                        )}

                        {mostrarCampoQuantidadePoltronas(
                            tipoConfiguracaoPrecoPrioritario
                        ) && (
                            <div className="col-12 col-sm-2 col-md-2 mt-2">
                                <label>Número de poltronas</label>
                                <Field
                                    name="quantidadePoltronasRegraPrioritario"
                                    type="text"
                                    component={renderFieldNumeros}
                                    valor={quantidadePoltronasRegraPrioritario}
                                    formatacao="##"
                                    css="form-control"
                                />
                            </div>
                        )}

                        <div className="col-12 col-sm-5 col-md-5">
                            <Field
                                name="vendedores"
                                options={usuariosVendedores.map((elemento) => ({
                                    descricao: elemento.valor,
                                    nome: elemento.chave,
                                }))}
                                component={renderFieldSelect}
                                label="Adicionar Usuarios Vendedores"
                                placeholder="Selecione um usuário"
                            />
                        </div>
                        <div
                            className="col-12 col-sm-3 col-md-2"
                            style={{ marginTop: '2.2rem' }}
                        >
                            <button
                                type="submit"
                                className="btn btn-sm btn-laranja"
                                onClick={onAdicionarPricePorUsuario}
                            >
                                Incluir
                            </button>
                        </div>
                        <div className="col-12 col-sm-12 col-md-10 mt-2">
                            <div className="lista-table">
                                {renderTabelaVendedores()}
                            </div>
                        </div>
                    </>
                )}
            </fieldset>
        </>
    );
};

export default FieldsetConfiguracaoPreco;

